import React, { useEffect, useState } from 'react';
import './Admin.css';
import { Link } from 'react-router-dom';
import AdminMenu from '../../components/AdminMenu';
import HeaderBottom from '../../components/HomePage/HeaderBottom';
import MarginTop from '../../MarginTop';
import { FaSearch, FaFilter, FaPaypal } from 'react-icons/fa'; // Importing icons

const TotalOrdersForAdminDashboard = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [ordersPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [orderStatusFilter, setOrderStatusFilter] = useState('');
    const [paymentStatusFilter, setPaymentStatusFilter] = useState('');

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/orders`)
            .then((res) => res.json())
            .then((info) => {
                const sortedOrders = info.sort((a, b) => {
                    const dateA = new Date(a.orderDate);
                    const dateB = new Date(b.orderDate);
                    return dateB - dateA; // Newest first
                });
                setOrders(sortedOrders);
                setFilteredOrders(sortedOrders);
            });
    }, []);

    // Handle Filters
    useEffect(() => {
        let filtered = orders;

        if (searchTerm) {
            filtered = filtered.filter(order =>
                order.customerName.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        if (orderStatusFilter) {
            filtered = filtered.filter(order => order.orderStatus === orderStatusFilter);
        }

        if (paymentStatusFilter) {
            filtered = filtered.filter(order => order.paymentStatus === paymentStatusFilter);
        }

        setFilteredOrders(filtered);
    }, [searchTerm, orderStatusFilter, paymentStatusFilter, orders]);

    // Pagination
    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <HeaderBottom />
            <section id="services" className="services-area vh-100">
                <div className="container">
                    <div className="row mb-4">
                        {/* Search Input */}
                        <div className="col-md-4 mb-3 mb-md-0">
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by Customer Name"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Order Status Filter */}
                        <div className="col-md-4 mb-3 mb-md-0">
                            <div className="input-group">
                                <select
                                    className="form-select"
                                    value={orderStatusFilter}
                                    onChange={(e) => setOrderStatusFilter(e.target.value)}
                                >
                                    <option value="">Filter by Order Status</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Delivered">Completed</option>
                                </select>
                            </div>
                        </div>

                        {/* Payment Status Filter */}
                        <div className="col-md-4">
                            <div className="input-group">
                                <select
                                    className="form-select"
                                    value={paymentStatusFilter}
                                    onChange={(e) => setPaymentStatusFilter(e.target.value)}
                                >
                                    <option value="">Filter by Payment Status</option>
                                    <option value="Paid">Paid</option>
                                    <option value="UnPaid">Unpaid</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Orders Table */}
                    <div className="row">
                        <div>
                            <h2 className="mb-4 text-center">Total Orders</h2>
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">SL.</th>
                                            <th scope="col">Order Date</th>
                                            <th scope="col">Customer Name</th>
                                            <th scope="col">Customer Email</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Order Status</th>
                                            <th scope="col">Payment Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentOrders.map((order, index) => (
                                            <tr key={order._id}>
                                                <th scope="row">{index + 1 + (currentPage - 1) * ordersPerPage}</th>
                                                <td>{order.orderDate}</td>
                                                <td>{order.customerName}</td>
                                                <td>{order.customerEmail}</td>
                                                <td>${order.packagePrice}</td>
                                                <td>
                                                    <span className={`badge ${order.orderStatus === 'Pending' ? 'bg-warning' : 'bg-success'}`}>
                                                        {order.orderStatus}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={`badge ${order.paymentStatus === 'Paid' ? 'bg-success' : 'bg-danger'}`}>
                                                        {order.paymentStatus}
                                                    </span>
                                                </td>
                                                <td>
                                                    <Link className="btn btn-primary" to={`/admin/payment-status/${order._id}`}>
                                                        Update Order
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            <nav aria-label="Orders Page Navigation">
                                <ul className="pagination justify-content-center">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <span className="page-link" onClick={() => paginate(currentPage - 1)}>Previous</span>
                                    </li>
                                    {Array.from({ length: Math.ceil(filteredOrders.length / ordersPerPage) }, (_, i) => (
                                        <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                            <span className="page-link" onClick={() => paginate(i + 1)}>
                                                {i + 1}
                                            </span>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === Math.ceil(filteredOrders.length / ordersPerPage) ? 'disabled' : ''}`}>
                                        <span className="page-link" onClick={() => paginate(currentPage + 1)}>Next</span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default TotalOrdersForAdminDashboard;
